export const labelStyle = {
  fontWeight: '500',
};
